import { c as _c } from "react/compiler-runtime";
import { LightButton } from '@systemeio/ui';
import React, { useEffect, useState } from 'react';
import { BaseTableProps } from 'shared/components/table/components/base-table';
import { InstanceWithIdType } from 'shared/components/table/types/instance-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { OrderEnum } from 'shared/types/pagination-interface';
export type PageTemplateLimitType = 9 | 15 | 30;
const limitArray: PageTemplateLimitType[] = [9, 15, 30];
interface PageTemplatePaginationProps<T> extends Pick<BaseTableProps<T>, 'data' | 'paginator'> {
  limiter: {
    limit: PageTemplateLimitType;
    setLimit: React.Dispatch<React.SetStateAction<PageTemplateLimitType>>;
  };
}
function PageTemplatePagination(t0) {
  const $ = _c(56);
  const {
    data,
    limiter,
    paginator
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    pagination,
    setPagination
  } = paginator;
  const {
    limit,
    setLimit
  } = limiter;
  const [isPaginationShown, setIsPaginationShown] = useState(true);
  const [isFirst, setIsFirst] = useState(true);
  const [isLast, setIsLast] = useState(false);
  let t1;
  if ($[0] !== data?.items.length || $[1] !== isFirst || $[2] !== setPagination) {
    t1 = () => {
      if (!isFirst && data?.items.length === 0) {
        setPagination({
          order: OrderEnum.next
        });
      }
    };
    $[0] = data?.items.length;
    $[1] = isFirst;
    $[2] = setPagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = data?.items.length;
  let t3;
  if ($[4] !== isFirst || $[5] !== setPagination || $[6] !== t2) {
    t3 = [t2, isFirst, setPagination];
    $[4] = isFirst;
    $[5] = setPagination;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t1, t3);
  let t4;
  let t5;
  if ($[8] !== data || $[9] !== pagination.order || $[10] !== pagination.startFromId) {
    t4 = () => {
      if (data) {
        setIsFirst(true);
        setIsLast(false);
        bb25: switch (pagination.order) {
          case "next":
            {
              if (pagination.startFromId) {
                setIsFirst(false);
              }
              if (!data.hasMore) {
                setIsLast(true);
              }
              break bb25;
            }
          case "prev":
            {
              if (data.hasMore) {
                setIsFirst(false);
              }
            }
        }
      }
    };
    t5 = [data, pagination.order, pagination.startFromId];
    $[8] = data;
    $[9] = pagination.order;
    $[10] = pagination.startFromId;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== data || $[14] !== isFirst || $[15] !== limiter.limit || $[16] !== pagination.order) {
    t6 = () => {
      if (data) {
        setIsPaginationShown(true);
        if (!isFirst || limiter.limit !== 9) {
          return;
        }
        if (pagination.order === "next" && !data.hasMore) {
          setIsPaginationShown(false);
        }
        if (data.items.length === 0) {
          setIsPaginationShown(false);
        }
      } else {
        setIsPaginationShown(false);
      }
    };
    $[13] = data;
    $[14] = isFirst;
    $[15] = limiter.limit;
    $[16] = pagination.order;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== data || $[19] !== isFirst || $[20] !== limiter.limit || $[21] !== pagination.order || $[22] !== pagination.startFromId) {
    t7 = [data, isFirst, limiter.limit, pagination.order, pagination.startFromId];
    $[18] = data;
    $[19] = isFirst;
    $[20] = limiter.limit;
    $[21] = pagination.order;
    $[22] = pagination.startFromId;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  useEffect(t6, t7);
  const t8 = `items-center justify-end gap-5 px-2 lg:px-0 ${isPaginationShown ? "flex" : "hidden"}`;
  let t9;
  if ($[24] !== data || $[25] !== limit || $[26] !== setLimit || $[27] !== setPagination) {
    t9 = limitArray.map(el => <button key={el} className={`ring-brand-primary flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-sm font-bold outline-hidden ring-offset-1 focus-visible:ring-2 ${limit === el ? "bg-background-secondary text-brand-primary" : "text-text-primary/50 bg-transparent "}`} disabled={data === undefined || data.items.length === 0} onClick={() => {
      setLimit(el);
      setPagination({
        startFromId: undefined,
        order: OrderEnum.next
      });
    }}>{el}</button>);
    $[24] = data;
    $[25] = limit;
    $[26] = setLimit;
    $[27] = setPagination;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t9) {
    t10 = <div className="flex gap-2">{t9}</div>;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== data?.items[0] || $[32] !== setPagination) {
    t11 = () => setPagination({
      startFromId: (data?.items[0] as InstanceWithIdType).id,
      order: OrderEnum.prev
    });
    $[31] = data?.items[0];
    $[32] = setPagination;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t) {
    t12 = t("global.previous");
    $[34] = t;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== isFirst || $[37] !== t11 || $[38] !== t12) {
    t13 = <LightButton disabled={isFirst} onClick={t11}>{t12}</LightButton>;
    $[36] = isFirst;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== data || $[41] !== setPagination) {
    t14 = () => setPagination({
      startFromId: (data?.items[data.items.length - 1] as InstanceWithIdType).id,
      order: OrderEnum.next
    });
    $[40] = data;
    $[41] = setPagination;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t) {
    t15 = t("global.next");
    $[43] = t;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== isLast || $[46] !== t14 || $[47] !== t15) {
    t16 = <LightButton disabled={isLast} onClick={t14}>{t15}</LightButton>;
    $[45] = isLast;
    $[46] = t14;
    $[47] = t15;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== t13 || $[50] !== t16) {
    t17 = <div className="flex gap-3">{t13}{t16}</div>;
    $[49] = t13;
    $[50] = t16;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== t10 || $[53] !== t17 || $[54] !== t8) {
    t18 = <div className={t8}>{t10}{t17}</div>;
    $[52] = t10;
    $[53] = t17;
    $[54] = t8;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  return t18;
}
export default PageTemplatePagination;